<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else>
            <FullCalendar
                :options="calendarOptions"
            />

            <EventInfoModal
                :modal-id="getCustomModalId('event', 1)"
                v-if="selectedEvent"
                :event="selectedEvent"
                @delete="deleteEvent"
            />
        </div>
    </div>


</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from '@fullcalendar/daygrid';
import TimeGridPlugin from '@fullcalendar/timegrid';
import ListPlugin from '@fullcalendar/list';
import InteractionPlugin from '@fullcalendar/interaction';
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import EventInfoModal from "./EventInfoModal.vue";
import CalendarService from "./services/CalendarService";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: "CalendarGrid",
    mixins: [ModalHandler, StyleHandler],
    components: {
        FullCalendar, EventInfoModal
    },
    props: {
        selectedCalendars: {
            type: Array
        },
        view: {
            type: String
        }
    },
    data() {
        return {
            loading: false,
            selectedEvent: null,
            period: {
                start: null,
                end: null,
                calendarIds: this.selectedCalendars ?? []
            },
            calendarOptions: {
                plugins: [dayGridPlugin, TimeGridPlugin, ListPlugin, InteractionPlugin],
                initialView: this.view,
                dateClick: this.handleDayClick,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                weekends: true,
                firstDay: 1,
                selectable: true,
                headerToolbar: {
                    left: 'prev today next',
                    center: 'title',
                    right: 'dayGridMonth timeGridWeek listWeek timeGridDay'
                },
                datesSet: this.handleDatesSet,
                events: [],
                eventTimeFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    meridiem: 'short'
                }
            }
        }
    },
    methods: {
        handleDatesSet(arg) {
            localStorage.setItem('calendarView', arg.view.type);
            this.period.start = arg.startStr
            this.period.end = arg.endStr
        },
        async deleteEvent(eventId) {
            try {
                await CalendarService.deleteEvent(eventId)
                $('#event-1').modal('hide');
                this.$showSuccessMessage('Event was deleted')
                await this.getListOfEvents()
            } catch (e) {
                this.$showErrorMessage('Your event was not deleted')
            }
        },
        async getListOfEvents() {
            try {
                const {data: response} = await CalendarService.getEventsForPeriod(this.period)
                this.calendarOptions.events = response.map(obj => {
                    return {
                        ...obj,
                        allDay: obj.transformed_all_day,
                        start: obj.start_date,
                        end: obj.transformed_end_date,
                        backgroundColor: this.getRGBAColor(obj.color ?? obj.calendar.color),
                        borderColor: this.getRGBAColor(obj.color ?? obj.calendar.color),
                        colorId: obj.color ?? obj.calendar.color,
                    };
                });
            } catch (e) {

            }
        },
        handleDayClick(info) {
            console.log('Clicked on day: ', info);
        },
        handleEventClick(info) {
            this.selectedEvent = {
                id: info.event.id,
                title: info.event.title,
                color: info.event.backgroundColor,
                ...info.event.extendedProps
            }
            this.showCustomModal('event', 1)
        },

    },
    watch: {
        'period.start': {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.getListOfEvents(newValue);
                }
            },
            immediate: false,
            deep: false
        },
        selectedCalendars(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.period.calendarIds = this.selectedCalendars
                localStorage.setItem("checkedCalendars", JSON.stringify(this.selectedCalendars));
                this.getListOfEvents()
            }
        }
    }


}
</script>

<style>

</style>
